var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-arrow-right",style:({ '--desktop-width': `${_vm.desktopWidth / 19.2}vw`, '--mobile-width': `${_vm.mobileWidth / 7.5}vw` })},[_c('div',{staticClass:"line",style:({ backgroundColor: _vm.color })}),_c('SvgIcon',{style:({ fill: _vm.color }),attrs:{"name":"arrow-right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }